// libs
import React from 'react';
import { memo } from 'react';
import cx from 'classnames';
// dls
import { Text } from '@swiggy-private/dls-web-core/dist/components/Text';
import { tokens } from '@swiggy-private/dls-web-common/dist/components/tokens';
// constants
import { IconDownload } from '@/constants/icons/svg';
import { DlsColorTokens, DlsFontVariants } from '@/constants/DLSTokens';
//components
import Modal from '@/components/Modal';
// styles
import styles from './GenerateReportButton.module.scss';
import ModalContent from './ModalContent';
const GenerateReportButton = ({ onClick, label, campaignIds, className, campaignName, }) => {
    const [modalOpen, setModalOpen] = React.useState(false);
    const handleOnClick = () => {
        onClick();
        setModalOpen(true);
    };
    const modalCallBack = (open) => {
        !open && setModalOpen(false);
    };
    const closeModal = () => setModalOpen(false);
    return (React.createElement(React.Fragment, null,
        React.createElement(Modal, { Content: ModalContent, closeOnOutsideClick: true, open: !!modalOpen, setOpen: modalCallBack, contentProps: { closeModal, campaignName, campaignIds } }),
        React.createElement("button", { className: cx(styles.button, className), onClick: handleOnClick },
            React.createElement(Text, { variant: DlsFontVariants.button_Text_BT3, color: DlsColorTokens.primary }, label),
            React.createElement(IconDownload, { className: styles.buttonIcon, fillColor: tokens.colors.orange1 }))));
};
export default memo(GenerateReportButton);
